"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PresetColors = void 0;
const PresetColors = ['blue', 'purple', 'cyan', 'green', 'magenta', 'pink', 'red', 'orange', 'yellow', 'volcano', 'geekblue', 'lime', 'gold'];
exports.PresetColors = PresetColors;